export const fontWeights = {
  light: 300,
  normal: 400,
  bold: 700,
};
